import "./styles.css";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ReactComponent as WhatsappSVG } from "../../img/Whatsapp.svg";
import Routes from "../../utils/Routes";

export default function FooterPrincipal({
    showQrPop=()=>{},
}) {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <>
    <div className="footer-ctn row flex-wrap justify-content-between justify-content-md-start">
      {!localStorage.getItem("jwtuser") && (
        <div className="agency-register col-12 col-sm-auto">
          <button
          className="border-0 bg-transparent p-0"
            onClick={() => {
              debugger
                history.push(Routes.bussinessLanding());
            }}
            >
            <p
              className="text-start"
            >
            {t("CreateAgency")}
            </p>
          </button>
        </div>
      )}
      <div className="qr-btn col-auto">
        <h4 className="text-start">{t("LandingQRCode1")}</h4>
        <button
          className="border-0 bg-transparent p-0"
            onClick={() => {
              showQrPop(true);
            }}
        >
        <p
        >
          {t("LandingQRCode2")}
        </p>
        </button>
      </div>
      {/*
                
      <Row>
        <Col className="footerBcont" xs={12} md="auto">
          <a href="#l"> {t("terms")}</a>
        </Col>
        <div className="line"> </div>
        <Col className="footerBcont" xs={12} md="auto">
          <a href="#l"> {t("privacyPolities")}</a>
        </Col>
      </Row>
      <div>
        <a href="#l">
          <img src={red_signal} alt="red_signal"></img>
          {t("areYouAdmin")}
        </a>
      </div><WhatsappSVG/>
                */}
    </div>
    <a href="https://wa.me/573168742911" target="_blank" rel="noreferrer" className="whatsapp-btn">
        <WhatsappSVG fill="currentColor" width="1em" height="1em"/>
        
         </a>
    </>
  );
}
